import ToastificationContent from '@/components/toastification/ToastificationContent'
import { getCurrentInstance, computed, h } from '@vue/composition-api'
export default function useDashboardHeader () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const initialLayout = computed(() => store.getters['$_dashboard/customDashboard'])
    const isEditMode = computed(() => store.getters['appConfig/dashboardEditMode'])
    const dashboardIdx = computed(() => store.getters['$_dashboard/customDashboardIdx'])
    const updateEditMode = (isEditMode) => {
        store.commit('appConfig/UPDATE_EDIT_MODE', isEditMode)
        store.commit('$_dashboard/UPDATE_EDIT_DASHBOARD', isEditMode ? [...initialLayout.value.map(item => ({ ...item }))] : [])
    }
    const isResetMode = computed(() => store.getters['appConfig/dashboardResetMode'])
    const checkIfEdited = computed(() => JSON.stringify(initialLayout.value) !== JSON.stringify(editDashboard.value))
    const updateResetMode = (isResetMode) => store.commit('appConfig/UPDATE_RESET_MODE', isResetMode)
    const editDashboard = computed(() => store.getters['$_dashboard/editDashboard'])

    const getCustomDashboardStatus = computed(() => store.getters['$_dashboard/getCustomDashboardStatus'])
    const saveCustomDashboardStatus = computed(() => store.getters['$_dashboard/saveCustomDashboardStatus'])

    const userIdx = computed(() => store.getters.authUserInfo.userIdx)
    const callSaveOrResetApi = () => {
        return isResetMode.value
            ? dashboardIdx.value
                ? store.dispatch('$_dashboard/resetCustomDashboard', { userIdx: userIdx.value, dashboardIdx: dashboardIdx.value })
                : Promise.resolve()
            : store.dispatch('$_dashboard/saveCustomDashboard', { userIdx: userIdx.value, coordinate: editDashboard.value })
    }
    const saveDashboard = () => {
        callSaveOrResetApi().then(() => {
            store.dispatch('$_dashboard/getCustomDashboard', { userIdx: userIdx.value }).then(() => {
                updateEditMode(false)
                vm.$hbToast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: vm.$t('org.message["Your dashboard has been saved."]'),
                        variant: 'success',
                        hideClose: true
                    }
                })
            })
        })
    }
    const SVGTimesIcon = h('svg', {
        attrs: {
            width: '20',
            height: '20',
            viewBox: '0 0 20 20',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
        }
    }, [
        h('path', {
            attrs: {
                d: 'M17 3L3 17',
                stroke: '#ACAAB1',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round'
            }
        }),
        h('path', {
            attrs: {
                d: 'M17 17L3 3',
                stroke: '#ACAAB1',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round'
            }
        })
    ])
    const headerVNode = h('button', {
        staticClass: 'close position-absolute',
        style: {
            right: '17px',
            top: '4px',
            fontSize: '1rem',
            padding: '5px'
        },
        attrs: {
            type: 'button'
        },
        on: {
            click: () => vm.$bvModal.hide('bvModal-dashboard-edit-cancel')
        }
    }, [
        SVGTimesIcon
    ])
    const cancelDashboard = () => {
        if (checkIfEdited.value) {
            vm.$bvModal.msgBoxConfirm(vm.$t('org.dashboard.If you leave the page without saving, all your work will be lost Are you sure you want to leave?'), {
                hideHeaderClose: true,
                id: 'bvModal-dashboard-edit-cancel',
                title: [vm.$t('org.dashboard.Notification'), headerVNode],
                headerClass: store.getters['appConfig/theme'] === 'dark' ? 'bg-transparent p-2 position-relative' : 'bg-white p-2 position-relative',
                titleClass: 'font-weight-bolder font-medium-2',
                bodyClass: 'noti-modal-body',
                footerClass: 'border-0 p-2',
                okTitle: vm.$t('org.dashboard.Leave'),
                cancelTitle: vm.$t('org.dashboard.Cancel'),
                centered: true,
                cancelVariant: 'noti-cancel'
            }).then((value) => {
                if (value) {
                    updateEditMode(false)
                }
            })
        } else {
            updateEditMode(false)
        }
    }

    return {
        isResetMode,
        isEditMode,
        updateEditMode,
        updateResetMode,
        saveDashboard,
        cancelDashboard,
        getCustomDashboardStatus,
        saveCustomDashboardStatus,
        checkIfEdited
    }
}
